// extracted by mini-css-extract-plugin
export default {"menu-list":"MenuDrawer_menu-list__um6cz","menu-logo":"MenuDrawer_menu-logo__iyHjq"};